// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ExitReportResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/exit_report/{order_item_id}.
 *
 * Returns the exit-report row, or null when no report exists yet for this
 * item (legacy behaviour: success=true with dados=null).
 */
import type { Orders_ExitReportRow } from './Orders_ExitReportRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_ExitReportResponseDados = Orders_ExitReportRow;

export type Orders_ExitReportResponse = ApiResponse<Orders_ExitReportResponseDados>;

registerResponseContract('Orders_ExitReportResponse', {
  _nullable:                    { type: 'boolean', required: false },
  so_exit_report_id:            { type: 'number',  required: false },
  so_exit_report_order_item_id: { type: 'number',  required: false },
  so_exit_report_observations:  { type: 'string',  required: false },
  so_exit_report_final_status:  { type: 'string',  required: false },
  so_exit_report_confirmed:     { type: 'number',  required: false },
  so_exit_report_confirmed_at:  { type: 'string',  required: false },
  so_exit_report_confirmed_by:  { type: 'string',  required: false },
  so_exit_report_created_at:    { type: 'string',  required: false },
  so_order_item_id:             { type: 'number',  required: false },
  so_order_item_service_id:     { type: 'number',  required: false },
  so_order_item_type:           { type: 'string',  required: false },
  so_order_item_description:    { type: 'string',  required: false },
  so_order_item_qrcode:         { type: 'string',  required: false },
  order_id:                     { type: 'number',  required: false },
  description:                  { type: 'string',  required: false },
  qr_code:                      { type: 'string',  required: false },
  client_name:                  { type: 'string',  required: false },
  client_phone:                 { type: 'string',  required: false },
  status:                       { type: 'string',  required: false },
  cliente_nome:                 { type: 'string',  required: false },
})
